module.exports = __webpack_public_path__ + "img/vn.06437358.svg";